import { useEffect, useState } from "react";
import { useBusiness } from "../../contexts/BusinessContext";
import { _post } from "../../services/apiClient";
import { Button } from "react-bootstrap";
import { apiUrls } from "../../config/apiUrls.const";
import InfoDisplay from "../components/InfoDisplay";
import { useNavigate } from "react-router-dom";
import LocationPickerMap from "../components/LocationPickerMap";

export default function BusinessInfo() {
  const { business } = useBusiness();
  const [info, setInfo] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBusinessInfo = async () => {
      try {
        if (!business?.biz_code) return;
        setLoading(true);
        const res = await _post<any>(apiUrls.getBusinessDetails, { biz_code: business.biz_code });
        setInfo(res.data?.data);
      } catch (err) {
        console.error("Failed to load business info:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchBusinessInfo();
  }, [business]);

  const editBusinessInfo = () => {
    if (!info) return;
    navigate("/business-info-edit", { state: { info } });
  };

  if (loading) {
    return <div className="container-fluid p-3">Loading business info...</div>;
  }

  if (!info) {
    return <div className="container-fluid p-3 text-danger">No business info found.</div>;
  }

  return (
    <div className="container-fluid p-0">
      <h1 className="h3 mb-3">
        Business Info
        <Button className="float-end" variant="primary" onClick={editBusinessInfo}>
          Edit Info
        </Button>
      </h1>

      <div className="row">
        <div className="col-12">
          <div className="card d-shadow">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <InfoDisplay label="Name" value={info.name} />
                  <InfoDisplay label="Code No" value={info.biz_code} />
                  <InfoDisplay
                    label="Logo"
                    value={
                      info.logo_path ? (
                        <img src={info.logo_path} alt="Logo" style={{ height: "60px" }} />
                      ) : (
                        <span className="text-muted">No logo uploaded</span>
                      )
                    }
                  />
                  <InfoDisplay label="Mobile No" value={info.mobile_no} />
                  <InfoDisplay label="Email" value={info.email} />

                  <div className="row">
                    <div className="col-6">
                      <InfoDisplay labelWidth="col-6" valueWidth="col-6" label="Division" value={info.division?.name_en} />
                    </div>
                    <div className="col-6">
                      <InfoDisplay labelWidth="col-6" valueWidth="col-6" label="District" value={info.district?.name_en} />
                    </div>
                    <div className="col-6">
                      <InfoDisplay labelWidth="col-6" valueWidth="col-6" label="Thana" value={info.thana?.name_en} />
                    </div>
                    <div className="col-6">
                      <InfoDisplay labelWidth="col-6" valueWidth="col-6" label="Postal Code" value={info.postal_code} />
                    </div>
                    <div className="col-12">
                      <InfoDisplay labelWidth="col-12" valueWidth="col-12" label="Address" value={info.address} />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row mb-3">
                    <div className="col-6">
                      Latitude: <strong>{info.latitude}</strong>
                    </div>
                    <div className="col-6">
                      Longitude: <strong>{info.longitude}</strong>
                    </div>
                  </div>

                  {/* <MapInput
                    mode="display"
                    lat={info.latitude}
                    lon={info.longitude}
                    mapHeight="250px"
                  /> */}

                  <LocationPickerMap
                    height="250px"
                    mode="preview"
                    value={{ lat: info.latitude, lng: info.longitude }}
                  />

                  <hr />
                  <div className="row">
                    <div className="col-6 mb-3">
                      Current Package:{" "}
                      <strong className="text-primary">{info.package}</strong>
                    </div>
                    <div className="col-6 mb-3">
                      Expiry Date:{" "}
                      <strong className="text-danger">{info.expiry_date}</strong>
                    </div>
                    <div className="col-6 mb-3">
                      Rating:{" "}
                      <strong className="text-primary">{info.rating || "N/A"}</strong>
                    </div>
                    <div className="col-6 mb-3">
                      Status:{" "}
                      <strong className={info.status ? "text-success" : "text-danger"}>
                        {info.status ? "Active" : "Inactive"}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
